import { PureComponent, isValidElement } from 'react'
import _ from 'lodash'
import cx from 'classnames'
import styles from './YCard.css'

import { Icon } from '@vzmi/shp_shared_compo'

export const NothingBlock = ({ iconType, text, className, children }) => {
  const classes = cx(styles.nothing, {
    [className]: !!className
  })
  return (
    <div className={classes}>
      <Icon
        name={iconType}
        size={150}
      />
      <span>{text}</span>
      {children}
    </div>
  )
}

export const YCardItem = ({ data, disabled, className, children }) => {
  const classes = cx(styles.yCardItem, {
    [className]: !!className,
    [styles.disabled]: !!disabled
  })
  return (
    <p
      className={classes}
      data-role='y-card--item'
    >
      {children}
    </p>
  )
}

export const YCardTitle = ({ title, content, children, className, ...props }) => {
  if (!content && !children) {
    return null
  }
  return (
    <h3
      className={cx(styles.title, { [className]: !!className })}
      {...props}
    >
      {content || children}
    </h3>
  )
}

const CollapseTrigger = ({ collapsable, onToggle, isActive, isDisabled }) => {
  const collapseClasses = cx(styles.collapse, {
    [styles['collapse-active']]: isActive,
    [styles['collapse-disabled']]: isDisabled
  })
  return collapsable
    ? (
      <div
        className={collapseClasses}
        onClick={onToggle}
      />
    )
    : null
}

export class YCard extends PureComponent {
  constructor (props) {
    super(props)

    this.getChildrenItems = this.getChildrenItems.bind(this)
    this.onCollapseToggle = this.onCollapseToggle.bind(this)
    this.state = {
      collapse: false
    }
  }

  onCollapseToggle () {
    this.setState({
      collapse: !this.state.collapse
    })
  }

  getChildrenItems () {
    /** collapsable works depending on number of chilren items, be sure to know this. */
    const collapsable = _.get(this.props, 'collapsable', false)
    const children = _.get(this.props, 'children', [])
    return (!_.isEmpty(children) && collapsable && !this.state.collapse) ? children.slice(0, 3) : children
  }

  render () {
    const { title, titleContent, className, collapsable, fluid, children } = this.props
    const childrenItems = this.getChildrenItems()
    const classes = cx(styles.yCard, {
      [className]: !!className,
      [styles.fluid]: fluid,
      [styles.collapsable]: collapsable
    })
    const titleElement = isValidElement(titleContent)
      ? titleContent
      : (
        <YCardTitle
          title={title}
          content={titleContent}
        />
      )
    return (
      <div
        className={classes}
        data-role='y-card'
      >
        <div className={styles.wrapper}>
          {titleElement}
          {childrenItems}
          <CollapseTrigger
            collapsable={collapsable}
            onToggle={this.onCollapseToggle}
            isActive={this.state.collapse}
            isDisabled={children.length <= 3}
          />
        </div>
      </div>
    )
  }
}

// export const YCardList = ({ data, className }) => {
//   const cardBlock = !_.isEmpty(data) ? data.map((localData, idx) => {
//     return <YCard key={idx} data={localData} />
//   }) : <NothingBlock />
//   return (
//     <div className={className}>
//       {cardBlock}
//     </div>
//   )
// }
